export const buildHrefLinkForRows = (paths: string, id: string) => {
  const domain = window.location.origin
  const policyPath =
    window.location.pathname.match(
      /\/policy\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?=\/|")/
    )?.[0] || `` // regex to match /policy/uuid
  return `${domain}${policyPath}/${paths}/${id}`
}
